import styled from 'styled-components'
import RatingStarIcon from '../../../assets/images/icon_rating_star.svg'
import { brandDarkGrey, brandGrey } from '../../../assets/consts/color'
import { secondaryFont } from '../../../assets/consts/fonts'

export const Container = styled.div`
  display: grid;
  gap: 24px;

  @media only screen and (min-width: 48em) {
    & p {
      font-size: 20px;
    }
  }
`

export const ReviewHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  & > h2 {
    margin-top: 0;
    font-size: 20px;
  }

  @media only screen and (min-width: 48em) {
    h2 {
      font-size: 28px;
    }
  }
`

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 48px;
  height: 48px;
  padding: 0;
  margin: 0;

  background-color: #d9d9d9;
  border-radius: 50%;

  & > h2 {
    margin-top: 0;
    font-size: 20px;
  }
`

export const ReviewFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 40px;

  border-bottom: 1px solid ${brandGrey};

  @media only screen and (min-width: 48em) {
    padding-bottom: 80px;
  }
`

export const DateWrapper = styled.div`
  p {
    font-size: 12px;
  }

  @media only screen and (min-width: 48em) {
    p {
      font-size: 16px;
    }
  }
`

export const RatingWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const RatingItem = styled.div`
  width: 18px;
  height: 18px;

  background: url(${RatingStarIcon}) no-repeat center;
`

export const AvatarTitle = styled.div`
  font-family: ${secondaryFont};
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
  color: ${brandDarkGrey};
`

export const ReviewHeaderTitle = styled.div`
  font-family: ${secondaryFont};
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.2;
  color: ${brandDarkGrey};

  @media only screen and (min-width: 48em) {
    font-size: 28px;
  }
`
